import { render, staticRenderFns } from "./col.vue?vue&type=template&id=3772741e&"
import script from "./col.vue?vue&type=script&lang=js&"
export * from "./col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports